<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item ><a @click="$router.back()">交易订单</a></el-breadcrumb-item>
      <el-breadcrumb-item>子订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
<!--    <el-form :inline="true" :model="formInline" class="user-search">-->
<!--      <el-form-item label="商品名称">-->
<!--        <el-input size="small" clearable v-model="formInline.productName" placeholder="请输入商品名称"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="物流单号">-->
<!--        <el-input size="small" clearable v-model="formInline.logisticsNo" placeholder="请输入物流单号"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="主订单编号">-->
<!--        <el-input size="small" clearable v-model="formInline.outTradeNo" placeholder="请输入订单编号"></el-input>-->
<!--      </el-form-item>-->
<!--&lt;!&ndash;      <el-form-item label="订单状态">&ndash;&gt;-->
<!--&lt;!&ndash;        <el-select size="small" clearable filterable v-model="formInline.tradeState" placeholder="请选择订单状态">&ndash;&gt;-->
<!--&lt;!&ndash;          <el-option&ndash;&gt;-->
<!--&lt;!&ndash;              v-for="company in payway"&ndash;&gt;-->
<!--&lt;!&ndash;              :key="company.value"&ndash;&gt;-->
<!--&lt;!&ndash;              :label="company.key"&ndash;&gt;-->
<!--&lt;!&ndash;              :value="company.value"&ndash;&gt;-->
<!--&lt;!&ndash;            ></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-select>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-form-item>&ndash;&gt;-->
<!--      <el-form-item >-->
<!--          <el-date-picker-->
<!--          size="small"-->
<!--          v-model="dateRange"-->
<!--          type="daterange"-->
<!--          @change="dateChange"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>-->
<!--      </el-form-item>-->
<!--    </el-form>-->
    <el-row style="margin-bottom: 10px">
<!--      <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>-->
    </el-row>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="selectChange" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
<!--      <el-table-column align="center" type="index" width="60"></el-table-column>-->
      <el-table-column prop="productName" label="商品名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="specName" label="商品规格名称" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="outTradeNo" label="子订单号" width="180" show-overflow-tooltip>
      </el-table-column>
<!--      <el-table-column prop="transactionId" label="微信订单编号" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
      <el-table-column prop="tradeStateDesc" label="交易状态描述	" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          {{ getStatus(payway,scope.row.tradeState)  }}
          <!-- {{scope.row.tradeState}} -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="totalNum" label="订单数量" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="totalAmount" label="订单总金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="redemptionPoints" label="使用积分数" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="mchid" label="商户id" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="userName" label="收货人姓名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="收货人电话" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" label="物流地址" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="logisticsNo" label="物流单号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="logisticsCompany" label="物流公司" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="receiptTime" label="签收日期" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="successDate" label="支付完成时间" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="freight" label="运费" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="thirdMsgs" label="第三方订单推送消息" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="250" fixed="right">
        <template slot-scope="scope">
<!--          scope.row.tradeState!='SHIPPED' ||-->
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" :disabled="scope.row.tradeState!='SHIPPED' || scope.row.thirdFlag=='2'" type="warning" plain @click="deleteUser(scope.row)">订单重推</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :inline="true">
            <el-form-item label="订单包含">
              <el-input size="small" v-model="editForm.productName" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input size="small" v-model="editForm.transactionId" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="交易状态描述">
              <el-input size="small" v-model="editForm.tradeStateDesc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select size="small" v-model="editForm.tradeState" placeholder="请选择订单状态" disabled>
                <el-option
                  v-for="company in payway"
                  :key="company.value"
                  :label="company.key"
                  :value="company.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单数量">
              <el-input size="small" v-model="editForm.totalNum" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单总金额">
              <el-input size="small" v-model="editForm.totalAmount" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="使用积分数">
              <el-input size="small" v-model="editForm.redemptionPoints" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="商户订单编号">
              <el-input size="small" v-model="editForm.outTradeNo" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="商户id">
              <el-input size="small" v-model="editForm.mchid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="支付完成时间">
              <el-input size="small" v-model="editForm.successDate" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-input size="small" v-model="editForm.createDate" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="运费">
              <el-input size="small" v-model="editForm.freight" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单数量">
              <el-input size="small" v-model="editForm.totalNum" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input size="small" v-model="editForm.logisticsNo" auto-complete="off" placeholder="请输入物流单号"></el-input>
            </el-form-item>
            <el-form-item label="物流公司">
              <el-select size="small" filterable v-model="editForm.logisticsCode" placeholder="输入搜索或选择">
                <el-option
                  v-for="company in companyOption"
                  :key="company.id"
                  :label="company.name"
                  :value="company.code"
                ></el-option>
              </el-select>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderListOfChild, findExpreCompany,OrderUpdate,customdeclareredeclare} from '../../api/payMG'
import {timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import {Loading} from "element-ui";
import {exportOrder} from "@/api/system";
import exportFile from '@/utils/exportFile'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      companyOption:[],
      payway: [
        { key: '待付款', value: 'PAID' },
        { key: '待发货', value: 'SHIPPED' },
        { key: '待收货', value: 'RECEIVED' },
        // { key: '待评价', value: 'EVALUATED' },
        { key: '已取消', value: 'CANCEL' },
        // { key: '支付失败', value: 'PAYERROR' },
        { key: '退货退款中', value: 'REFUNDGOODING' },
        { key: '退货退款成功', value: 'REFUNDGOOD' },
        { key: '退货退款失败', value: 'REFUNDGOODERR' },
        { key: '退款成功', value: 'REFUND' },
        { key: '订单完成', value: 'POSTSALE' },
        { key: '退款中', value: 'REFUNDING' },
      ],
      dateRange:null,
      editForm: {
        id: '',
      },
      formInline: {
        id:null
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      ids: '',
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.formInline.id = id
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取快递公司列表
    getCompanyList(){
     return findExpreCompany().then(res=>{
      return this.companyOption = res.body
      })
    },
    dateChange(v){
      console.log(v);
      this.formInline.startDate	= v[0]
      this.formInline.endDate	= v[1]
    },
    // 获取表格数据
    getdata(parameter) {
      this.loading = true
      OrderListOfChild(parameter)
        .then(res => {
          this.loading = false
          console.log(res.rsp_code)
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.listData = res.rows
            console.log(this.listData);
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    // selection选择
    selectChange(selection) {
      // console.log('selection',selection);
      // if (selection.length > 0) {
      //   this.isGroundingBtn = false
      // } else {
      //   this.isGroundingBtn = true
      // }
      let ids;
      ids = selection.map(item => item.id)
      this.ids = ids.join()
    },
    //显示编辑界面
    async handleEdit(index, row) {
      await this.getCompanyList()
      this.title = "编辑"
      this.editForm = row
      this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          OrderUpdate(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.rsp_code ==200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(row) {
      this.$confirm('确定要重推吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          customdeclareredeclare(row.id)
            .then(res => {
              if (res.rsp_code==200) {
                this.$message({
                  type: 'success',
                  message: res.rsp_msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    getStatus(statusOption,statusName){
       let statusObj = statusOption.filter( statusItem => statusName == statusItem.value )
       return statusObj[0].key
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download('system/goods/export', {
      //   ...this.queryParams
      // }, `goods_${new Date().getTime()}.xlsx`)
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      exportOrder({ids: this.ids}).then(res => {
        exportFile.getExcel(res, `productList_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
  }
}
</script>

<style scoped>
.el-select{
  width: 100%;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/pay/childrenOrder.vue